import styled from 'styled-components';
import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const SetUpList = styled.ul`
  margin: 10px 0 0;
  padding: 5px 0 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 155px;
`;

export const SetUpListItem = styled.li`
  font-size: 24px;
  line-height: 1.25;
  margin-left: 15px;
`;

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    setupViewOuterContainer: {
      padding: '0 0',
      overflow: 'hidden',
      borderRadius: '16px',
      height: '879px',
      [theme.breakpoints.down('lg')]: {
        height: '1700px'
      },
      [theme.breakpoints.only('lg')]: {
        height: '840px',
        padding: '0px 28px 0px 28px'
      }
    },
    setupViewTextBlock: {
      flex: 'none',
      background: 'transparent',
      padding: '80px 64px 16px 64px',
      [theme.breakpoints.down('lg')]: {
        padding: '80px 173px 16px 181px'
      },
      [theme.breakpoints.only('lg')]: {
        padding: '80px 30px 0px 45px'
      }
    },
    setupViewSubHeading: {
      fontWeight: 600,
      fontFamily: 'Poppins, sans-serif',
      fontSize: '32px',
      [theme.breakpoints.down('lg')]: {
        fontSize: '24px'
      }
    },
    setupListItemBox: {
      '& > * ': {
        [theme.breakpoints.down('lg')]: {
          height: '100px'
        }
      },
      '& > * >*': {
        fontSize: '30px'
      }
    },
    setupViewBeginButton: {
      display: 'flex',
      margin: '96px 0px 96px 0px',
      background: 'transparent',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'start',
        margin: '61px 0px 150px 0px'
      },
      [theme.breakpoints.only('lg')]: {
        margin: '100px 0px 125px 0px'
      }
    },
    setupViewImageContainer: {
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%'
      }
    },
    setupViewTextContainer: {
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%'
      }
    }
  })
);
